export default __webpack_public_path__ + "static/media/section-element.3a353f55.svg";